import React from "react";

import { Card, CardActionArea, CardActions, CardContent, Divider, Grid, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import RadarChart from "pages/customer/insights/portfolioNew/filters/RadarChart";

import { Store } from "modules/customer/insights/portfolioNew/store";
import numberFormatter from "utils/numberFormatter";

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main,
        borderColor: (props: any) => props["data-selected"] ? theme.palette.common.white : "transparent",
        borderStyle: "solid",
        borderWidth: "1px",
        height: "100%"
    }
}))(Card);

const StyledCardActions = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.light,
        height: theme.spacing(15)
    }
}))(CardActions);

const StyledCardActionArea = withStyles(theme => ({
    root: {
        height: "100%",
        minWidth: "100%"
    }
}))(CardActionArea);

const StyledCardContent = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main
    }
}))(CardContent);

interface StoreCardProps {
    store: Store,
    selected: boolean,
    onSelect: (store: Store) => void,
    onDeselect: (store: Store) => void
}

const StoreCard: React.FC<StoreCardProps> = (props) => {
    const theme = useTheme();
    const { store, selected, onSelect, onDeselect } = props;

    const handleClick = () => {
        if (selected) {
            onDeselect(store);
        } else {
            onSelect(store);
        }
    };

    return (
        <StyledCard elevation={0} data-selected={selected}>
            <StyledCardActionArea onClick={handleClick} disableRipple disableTouchRipple>
                <StyledCardActions>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h6"
                                component="div"
                                align="center"
                            >
                                {store.name}
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography
                                variant="body2"
                                component="div"
                                align="center"
                                noWrap
                                style={{ color: theme.palette.text.secondary }}
                            >
                                Revenue
                            </Typography>
                            <Typography
                                variant="h6"
                                component="div"
                                align="center"
                            >
                                {numberFormatter.toGBP(store.revenue, 1)}
                            </Typography>
                        </Grid>
                        <Divider orientation="vertical" flexItem style={{ marginRight: "-1px" }} />
                        <Grid item xs={4}>
                            <Typography
                                variant="body2"
                                component="div"
                                align="center"
                                noWrap
                                style={{ color: theme.palette.text.secondary }}
                            >
                                Gross Profit
                            </Typography>
                            <Typography
                                variant="h6"
                                component="div"
                                align="center"
                            >
                                {numberFormatter.toPercentage(store.grossProfitMargin, false, 0)}
                            </Typography>
                        </Grid>
                        <Divider orientation="vertical" flexItem style={{ marginRight: "-1px" }} />
                        <Grid item xs={4}>
                            <Typography
                                variant="body2"
                                component="div"
                                align="center"
                                noWrap
                                style={{ color: theme.palette.text.secondary }}
                            >
                                {"Revenue/ft²"}
                            </Typography>
                            <Typography
                                variant="h6"
                                component="div"
                                align="center"
                            >
                                {store.displayRevenuePerSquareFoot()}
                            </Typography>
                        </Grid>
                    </Grid>
                </StyledCardActions>
                <StyledCardContent>
                    <RadarChart
                        revenue={store.revenue}
                        revenueScore={store.revenueScore}
                        profit={store.grossProfitMargin}
                        profitScore={store.profitScore}
                        changeInNumberOfStores={store.changeInNumberOfStores}
                        areaHealthScore={store.areaHealthScore}
                        catchmentSize={store.catchmentSize}
                        catchmentScore={store.catchmentScore}
                        numberOfCompetitors={store.numberOfCompetitors}
                        competitionScore={store.competitionScore}
                        footfallLevel={store.footfallLevel}
                        footfallScore={store.footfallScore}
                        totalScore={store.getTotalScore()}
                    />
                </StyledCardContent>
            </StyledCardActionArea>
        </StyledCard>
    );
};

export default StoreCard;
